import SmoothScroll from 'smooth-scroll';
// from https://github.com/cferdinandi/smooth-scroll

export default class InnerScroll {
  init() {
    const scroll = new SmoothScroll('a[href*="#"]', {
      speed: 1000,
      easing: 'easeInOutCubic',
      speedAsDuration: true,
      header: '.l-header'
    });

    // 固定headerの場合
    // const scroll = new SmoothScroll('a[href*="#"]', {
    //     header: '.l-header'
    // });
  }
}
